import generalUtilities from '@/services/utilities/general';
import ranksUtilities from '@/services/utilities/ranks';
import handsUtilities from '@/services/utilities/hands';
import resultsUtilities from '@/services/utilities/results';

export default {
  general: generalUtilities,
  ranks: ranksUtilities,
  hands: handsUtilities,
  results: resultsUtilities,
};



// WEBPACK FOOTER //
// ./src/services/utilities/utilities.js